import { ReactComponent as CloseSVG } from "assets/icons/close-sm.svg";
import React from 'react';
import { fontConfig } from "theme/fontConfig";
 
const AddTagField = ({ tags, removeTagHandler, fieldClickHandler,disabled }) => {
  return (
    <div className={`add-tag-field ${disabled? "add-tag-field-disabled" : ""}`}>
      {tags?.length > 0 && tags?.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag, i) => {
        return (
          <div className="add-tag-field-item" key={tag}>
            {tag}
            <span
              style={{
                marginLeft: '5px',
                fontSize: '12px',
                fontWeight: '400',
                cursor: 'pointer',
              }}
              onClick={() => {
                removeTagHandler(tag);
              }}
            >
              <CloseSVG />
            </span>
          </div>
        );
      })}
      <div className="add-tag-field-button">
        <span
          style={{
            color: '#B5B5C3',
            fontFamily: fontConfig.MemberDetailsAddTagFieldTextFont.family,
            fontWeight: '500',
            fontSize: '13px',
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={fieldClickHandler}
        >
          <strong>+</strong> Add a tag
        </span>
      </div>
    </div>
  )
}

export default AddTagField